module.exports = "https://trybtryb-legacy.web.app/img/uploader-img.410ea76d.svg";